import { css } from "@emotion/react";
import primaryButtonCss from "assets/css/buttons/primaryButton.css";
import colors from "assets/css/colors";
import { contentCss } from "assets/css/content.css";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";
import lineHeight from "assets/css/lineHeight";

export const pageHeaderContainerCss = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const buttonCss = [
  primaryButtonCss,
  css`
    width: fit-content;
    &:active,
    &:hover {
      background-color: ${colors.darkBlue};
      box-shadow: unset;
    }
  `,
];

export const overlayCss = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  display: block;
  padding: 60px 20px;
  z-index: 1000;
`;

export const modalCss = css`
  margin: 0 auto;
  width: calc(100vw - 40px);
  max-width: 900px;
  background-color: ${colors.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const modalContentCss = css`
  height: 100%;
  width: 100%;
`;

export const modalContainerCss = [
  contentCss,
  css`
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 24px 20px;
  `,
];

export const leftCss = css`
  min-height: 600px;
  min-width: 330px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const sectionCss = css`
  display: flex;
  flex-direction: column;
  flex: 0 auto;
`;

export const titleCss = css`
  color: ${colors.mainBlack};
  font-size: ${fontSize.xl};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.md};
`;

export const inputWrapperCss = css`
  width: 350px;
`;

export const leftContainerCss = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const rightContainerCss = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 16px;
`;

export const tabsContentCss = css`
  display: flex;
  gap: 100px;
  height: 100%;
  width: 100%;
`;
